import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_11_11() {
  return (
    <NoteContainer date={'11/11/2025'} version="20.20.1">
      <VStack w="full">
        <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento', 'novafriburgo']}>
          <ModuleContainer moduleName="SCHEDULES">
            <VStack w="full">
              <CategoryContainer category="FEATURE">
                <Box>
                  <TaskTitle important={true}>Campo de horário de saída adicionado no agendamento</TaskTitle>
                  <TaskBreadcrumb>Agendas/ Agenda</TaskBreadcrumb>
                  <TaskDescription>
                    Agora, ao criar um agendamento o usuário irá precisar selecionar um horário de saída
                  </TaskDescription>
                </Box>
                <Box>
                  <TaskTitle important={true}>Agendamentos vinculados com a entrada na fila</TaskTitle>
                  <TaskBreadcrumb>Agendas/ Agenda</TaskBreadcrumb>
                  <TaskDescription>
                    Agora, a tag de agendado vinculado com a entrada da tag, lista todos os agendamentos para aquela
                    entrada especifica
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ExclusiveContainer category="ADJUSTMENTS" institutions={['teste', 'treinamento', 'novafriburgo']}>
          <ModuleContainer moduleName="ATTENDANCES">
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle important={true}>Campo de horário de saída adicionado no fluxo de agendamento</TaskTitle>
                  <TaskBreadcrumb>Atendimento/ Recepção</TaskBreadcrumb>
                  <TaskDescription>Nova coluna adicionada na tabela: Horário de saída</TaskDescription>
                </Box>
                <Box>
                  <TaskTitle important={true}>Campo de saída é criado de maneira automática no atendimento</TaskTitle>
                  <TaskBreadcrumb>Atendimento/ Recepção</TaskBreadcrumb>
                  <TaskDescription>
                    Horário de saída é criada de maneira automática durante a criação de um atendimento derivado de um
                    agendamento
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="ASSESSMENTS_AND_RESEARCH">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Alteração de URL do gerador de QR Code</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Gerar QR Code</TaskBreadcrumb>
                <TaskDescription>
                  Correção do link, agora o link está redirecionando à pesquisa via totem
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
